export default __webpack_public_path__ + "static/media/deal-11.309f0c41.webp";